import type { RutaProd } from '../../../../runtime/rutas';
export default {
  ruta: '/sistema/inventory/Informe',
  documento: 'inventory',
  acceso: 'sesion',
  filas: ['078'],
  cita: 'Areas/Inventory/Controllers/InventoryController.cs:1081',
} satisfies RutaProd;
